import { connect } from "react-redux";
import { selectCurrentModalWithType } from "../../selectors/selectCurrentModalWithType";
import { componentWithProps } from "../generic/componentWithProps";
import { TypeModal } from "../modals/TypeModal";
export var ErrorDialogManagerDOM = connect(selectCurrentModalWithType(TypeModal.ErrorDialog))(componentWithProps);



//////////////////
// WEBPACK FOOTER
// ./src/features/dialog/ErrorDialogManagerDOM.tsx
// module id = 1123
// module chunks = 3